"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagHyIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagHyIcon = (0, _mobxReact.observer)(_class = (_FlagHyIcon = /*#__PURE__*/function (_React$Component) {
  function FlagHyIcon() {
    _classCallCheck(this, FlagHyIcon);
    return _callSuper(this, FlagHyIcon, arguments);
  }
  _inherits(FlagHyIcon, _React$Component);
  return _createClass(FlagHyIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 100 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#00BAE5",
        x: "0",
        y: "0",
        width: "100",
        height: "33.3"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#EE2436",
        x: "0",
        y: "33",
        width: "100",
        height: "34"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#3D9D32",
        x: "0",
        y: "66.7",
        width: "100",
        height: "33.3"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FFFFFF",
        points: "69.7 49.9 65.4 48.3 67.3 44.1 63.1 46.1 61.5 41.8 61.5 41.8 61.5 41.8 61.5 41.8 61.5 41.8 59.9 46.1 55.8 44.1 57.7 48.3 53.3 49.9 57.7 51.6 55.7 55.8 59.9 53.7 61.5 58.1 61.5 58.1 61.5 58.1 61.5 58.1 61.5 58.1 63.1 53.7 67.4 55.8 65.4 51.6"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M48.5,62.4 C41.6,62.4 36.1,56.8 36.1,50 C36.1,43.1 41.7,37.6 48.5,37.6 C52.2,37.6 55.6,39.3 57.8,41.9 C55.1,37.8 50.5,35 45.2,35 C36.9,35 30.2,41.7 30.2,50 C30.2,58.3 36.9,65 45.2,65 C50.5,65 55.1,62.3 57.8,58.1 C55.6,60.8 52.2,62.4 48.5,62.4 Z",
        id: "Path",
        fill: "#FFFFFF"
      }))));
    }
  }]);
}(_react["default"].Component), _FlagHyIcon.defaultProps = {
  width: '20px'
}, _FlagHyIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagHyIcon);